import React, { memo } from 'react';
import PrivateLayout from '@Components/Layouts/PrivateLayout';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import AuthenWrapper from '@Components/AuthenWrapper';
import { useSelector } from 'react-redux';
import PageErrorPermission from '../../views/PageErrorPermission';

function isPrivilegedUser(userInfo) {
  if (!userInfo) {
    return false;
  }

  if (userInfo?.is_super_admin) {
    return true;
  }

  const rolesByProject = userInfo?.roles_by_project || {};
  const roleGroups = Object.values(rolesByProject);

  return roleGroups.some(
    (roles) => Array.isArray(roles) && roles.some((role) => String(role).toLowerCase().includes('admin')),
  );
}

function PrivateRoutes(props) {
  const { component: YourComponent, accessName, accessChild, ...remainProps } = props;
  const accessPermissions = useSelector((state) => state.user.accessPermisions);
  const userInfo = useSelector((state) => state.user.info);
  return (
    <AuthenWrapper>
      <Route
        {...remainProps}
        render={(routeProps) => {
          if (accessPermissions) {
            const isPrivileged = isPrivilegedUser(userInfo);
            const hasParentAccess = isPrivileged || !accessName || !!accessPermissions[accessName];
            const hasChildAccess = isPrivileged || !accessChild || !!accessPermissions[accessChild];

            const canAccessRoute = accessChild ? hasChildAccess : hasParentAccess;

            if (canAccessRoute) {
              return (
                <PrivateLayout>
                  <YourComponent {...routeProps} />
                </PrivateLayout>
              );
            }
            return <PageErrorPermission />;
          }
          return '';
        }}
      />
    </AuthenWrapper>
  );
}

PrivateRoutes.propTypes = {
  component: PropTypes.object,
  accessName: PropTypes.string,
  accessChild: PropTypes.string,
};

export default memo(PrivateRoutes);
